import styled from 'styled-components';

// Styled label component (for backward compatibility)
export const ToggleBtn = styled.label`
  position: relative;
  display: inline-block;
  width: 46px;
  height: 26px;
  margin: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .onoff-switch {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px;
    background-color: #ccc;
    transition: 0.2s;
    width: 46px;
  }
  .onoff-switch:before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 2px;
    bottom: 2px;
    background-color: #fff;
    transition: 0.2s;
    border-radius: 20px;
  }
  input:checked + .onoff-switch {
    background-color: ${({ theme }) => theme.primary};
  }
  input:checked + .onoff-switch:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(20px);
  }

  .disabled {
    cursor: not-allowed !important;
  }

  .tootip-text {
    position: absolute;
    width: 10vw;
  }
`;

// Props interface for ToggleSwitch component
interface ToggleSwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

// Functional React component that handles checked and onChange props
const ToggleSwitch = ({ checked = false, onChange, disabled = false }: ToggleSwitchProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <ToggleBtn>
      <input type="checkbox" checked={checked} onChange={handleChange} disabled={disabled} />
      <span className={`onoff-switch ${disabled ? 'disabled' : ''}`} />
    </ToggleBtn>
  );
};

export default ToggleSwitch;
